import type { Subtodo } from 'owa-todo-types';
import { createSubtodos } from 'owa-todo-actions';
import { showRetryNotification } from 'owa-timestream-store';
import getUnsuccessfullyCreatedSubtasks from './getUnsuccessfullyCreatedSubtasks';
import loc from 'owa-localize';
import { failedToCreateSubtask } from './createTaskErrors.locstring.json';

export default function createSubtasks(parentTaskId: string, subtasks: Partial<Subtodo>[]) {
    createSubtodos(subtasks, parentTaskId, {
        actionSource: 'SpacesTaskAsset',
        viewType: 'QuickAdd',
    }).then(result => {
        if (!result.success) {
            showRetryNotification('createSubtask', loc(failedToCreateSubtask), retry => {
                if (retry) {
                    createSubtasks(
                        parentTaskId,
                        getUnsuccessfullyCreatedSubtasks(subtasks, result.items)
                    );
                }
            });
        }
    });
}
